<template>
  <div class="layout-wrapper">
    <login v-if="!isLogin" :allConfig="allConfigLogin" :hasKey="hasKey"></login>
    <el-container style="height: 100%" v-else>
      <!-- 头部 -->
      <el-header class="custom-header">
        <Header @add-tab="addTab" />
      </el-header>
      <el-container :style="{ height: tableMaxHeight + 150 + 'px' }">
        <!-- 左侧菜单 -->
        <side-bar :ready="sidebarReady" @add-tab="addTab" @default-Page="getDefaultPage" ref="sidebar" />
        <!-- 中间内容 -->

        <el-main>
          <el-tabs class="custom-tabs" v-model="editableTabsValue" type="card" closable @tab-click="clickTab"
            @tab-remove="removeTab">
            <el-tab-pane class="custom-tab-pane" v-for="(item, index) in editableTabs" :key="item.index"
              :name="item.index">
              <template #label>
                <el-popover :disabled="!item.remarks" v-model="item.isTips" trigger="click"
                  :popper-class="`popper-${item.title}`" placemen="bottom-start" :close-delay="50">
                  <span slot="reference">
                    <span>{{ item.title }}</span>
                    <span class="icon-warning" v-if="item.remarks"> ?</span>
                  </span>
                  <div class="tips">
                    <div class="header">
                      <div class="title gray">页面备注</div>
                      <i class="el-icon-close" style="cursor: pointer" @click="clickDeleteIcon(index,item)"></i>
                    </div>
                    <div class="content" v-html="item.remarks"></div>
                    <div class="tipBtn" v-if="item.prompt || showTips" @click="noTip(item)">
                      不再提醒
                    </div>
                  </div>
                </el-popover>
              </template>
              <div :id="`subapp-viewport-${item.component}-${item.index}`"
                :style="{height:appErrors[item.component]?'0px':'100%'}">
              </div>
              <div>
                {{appErrors[item.component]}}
              </div>
            </el-tab-pane>
          </el-tabs>

        </el-main>

      </el-container>
      <!-- 工作状态切换 -->
      <workstate-switch :ready="sidebarReady" @permission="getIsPermission" :workState="workState" v-if="isShowWorkState"
        ref="workStateSwitch"></workstate-switch>

      <!-- 系统消息自动推送 -->
      <SystemMessageDialog @changeWorkState="changeWorkState" @add-tab="addTab" v-if="isState && permissionId === 0"
        ref="systemMessageDialog">
      </SystemMessageDialog>
    </el-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import Header from "views/layout/Header";
  import SideBar from "views/layout/SideBar";
  import Login from "views/LoginNew";
  import WorkstateSwitch from "components/WorkStateSwitch.vue";
  import SystemMessageDialog from "components/SystemMessageDialog.vue";
  import { logIn1, saveloginInfo, loginRoleInformation, logOut,GetAdminLoginToken,loginUserInfo } from "network/login";
  import {loginRoleInformationV2} from "network/projectLogin";
  import { isNull, hexToRgb } from "../common/utils";
  import { studentComponents, adminComponents, orderComponents, productComponents, reportComponents, teachComponents, wordComponents, invoicingComponents , marketingComponents} from "../common/modelComponents";

  const version = require("element-ui/package.json").version; // element-ui version from node_modules
  const ORIGINAL_THEME = "#409EFF"; // default color
  import { defaultColor, defaultThemeStyle } from "common/const";
  import Tooltip from "@/components/Tooltip/index.vue";
  import { uniqBy } from "lodash";

  // qiankun
  import { registerMicroApps, start, loadMicroApp, initGlobalState, setGlobalState } from 'qiankun';
  import actions from '../main.js';

  export default {
    inject: ["reload"], // 注入方法
    name: "Index",
    components: {
      Header,
      SideBar,
      Login,
      WorkstateSwitch,
      SystemMessageDialog,
      Tooltip,
    },
    props: {
      allConfig: {
        type: Object,
        default: () => { },
      },
    },
    data() {
      return {
        // 当前打开的tab
        editableTabsValue: "51",
        // 当前显示的tabpane组件
        editableTabs: [],
        // 默认打开的tabpane组件
        comps: [
          // {
          //   title: "请假管理",
          //   name: "66",
          //   content: "请假管理",
          //   component: "StudentLeaveRecordList",
          // },
        ],
        isShowWorkState: true, //展示工作状态
        isState: true,
        allConfigLogin: {},
        openPageData: "", //组件传递的参数
        queryAdminId: null, //地址栏query管理员id
        default: 0,
        defaultName: "",
        isFlag: true,
        isDefaultFlag: true, //默认页面状态
        showIcon: false,
        popoverShow: false,
        isShowTips: false,
        isHover: true,
        timer: null,
        showTips: false,
        closeDelay: 3000,
        delayMenuList: [],
        openAgin: [],//重新打开的窗口
        AdminToken: [],
        workState: null,
        loadedInstances: {},
        appErrors: {},
        isWaitingForMenuData: false, // 防止重复注册菜单数据加载事件监听器
        isDingLoginProcessing: false, // 防止钉钉登录跳转重复执行
        hasKey:"",
        // 控制 SideBar/WorkstateSwitch 是否触发初始化逻辑
        sidebarReady: false,
        
      };
    },
    computed: {
      //临时授权id，大于0时不显示导航栏的项目切换及修改密码功能
      permissionId(){
        let adminCache = null;
        if(this.$store.state.AdminCache) {
          adminCache = this.$store.state.AdminCache;
        }else if (sessionStorage.getItem("AdminCache")) {
          adminCache = JSON.parse(sessionStorage.getItem("AdminCache"));
        }   
        return adminCache?.permissionId;
      },
      // 拿到当前登录adminId值
      adminId() {
        if (
          this.$store.state &&
          this.$store.state.AdminCache &&
          this.$store.state.AdminCache.adminId
        ) {
          return this.$store.state.AdminCache.adminId;
        } else if (sessionStorage.getItem("AdminCache")) {
          return JSON.parse(sessionStorage.getItem("AdminCache")).adminId;
        } else {
          return this.queryAdminId;
        }
      },
      // 已登录标识
      isLogin() {
        return this.$store.state.isLogin || sessionStorage.getItem("isLogin");
      },
      // 表的最大高度:动态计算
      tableMaxHeight() {
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        if (h > 768) {
          return h - 210;
        } else {
          return h + 100;
        }
      },
      microAppActive() {
        const { appInfo } = this.$route.meta;
        return appInfo && this.$qiankun.isMicroAppActive(appInfo.name);
      },
    },
    watch: {
      // 监听adminId值是否改变，判断账号切换后刷新列表
      // adminId(newValue, oldVal) {
      //   if (newValue != oldVal) {
      //     this.reload();
      //   }
      // },
      //全局配配置
      allConfig(newValue) {
        this.allConfigLogin = newValue;
      },
      //监听浏览器是否有adminToken
      AdminToken: {
        // immediate: true,
        handler(newVal) {
          if (newVal) {
          let adminId;
          if (
            this.$store.state &&
            this.$store.state.AdminCache &&
            this.$store.state.AdminCache.adminId
          ) {
            adminId = this.$store.state.AdminCache.adminId;
          } else if (sessionStorage.getItem("AdminCache")) {
            adminId =  JSON.parse(sessionStorage.getItem("AdminCache")).adminId;
          } else {
            adminId =  this.queryAdminId;
          }
          //  if ( adminId != newVal) {
          //   this.queryAdminId = newVal;
          //   this.isState = false
          //   this.submitClick(newVal);
          // }
        }
        },
        deep: true,
        immediate: true,
      },
    },
    
    created() {
      const url = new URL(window.location.href);
      const key = url.searchParams.get("key");
      // 先拿到 hasKey，再计算 sidebarReady
      this.hasKey = key || "";
      // sidebarReady 默认使用 hasKey 取反；如果 mounted 中检测到 key，会再强制设为 true
      this.sidebarReady = !this.hasKey;
      let style;
      if (
        this.$store.state &&
        this.$store.state.themeStyle &&
        this.$store.state.themeStyle.ThemeColor
      ) {
        style = JSON.parse(this.$store.state.themeStyle);
      }
      if (sessionStorage.getItem("themeStyle")) {
        style = JSON.parse(sessionStorage.getItem("themeStyle"));
      } else {
        style = defaultThemeStyle;
      }
      this.getColorData(style);
      if (sessionStorage.getItem("AdminToken")) {
        this.AdminToken = sessionStorage.getItem("AdminToken")
          ? JSON.parse(sessionStorage.getItem("AdminToken"))
          : [];
      }
      

    },
     async mounted() {
      // 使用URLSearchParams获取查询参数
      const url = new URL(window.location.href);
      const key = url.searchParams.get("key");
      if(key){
        sessionStorage.clear();
        this.hasKey = key;
        await this.GetAdminLoginTokenData(key)
        // 有 key 时也让 sidebarReady 为 true
        this.sidebarReady = true;
        // 删除地址栏参数，保留 hash
        const cleanUrl = window.location.origin + window.location.pathname + (window.location.hash || "#/");
        window.history.replaceState({}, document.title, cleanUrl);
      } else {
          const storedToken = sessionStorage.getItem("token");
          if (storedToken) {
            this.getInfo();
          }
      }
      this.$nextTick(() => {
        const navList = document.querySelector(".el-tabs__nav");
        navList?.addEventListener("mouseenter", this.currentHover);
      });
      
      // 监听钉钉登录检查事件
      this.$root.$on('triggerDingLoginCheck', this.checkAndHandleDingLogin);
     },
     beforeDestroy() {
       // 移除事件监听器
       this.$root.$off('triggerDingLoginCheck', this.checkAndHandleDingLogin);
     },
      methods: {
        //根据Key获取登录token
        async GetAdminLoginTokenData(key){
          try {
            const res = await GetAdminLoginToken({ key: key });
            if (res?.data?.code == 1) {
              const tokenData = res.data.result;
              let expiresTime = tokenData.expires_in + new Date() / 1000;
              const token = {
                AccessToken: tokenData.access_token,
                AccessExpiresIn: expiresTime,
                RefreshToken: tokenData.refresh_token,
              };
              this.$store.commit("saveTokenStorage", token);
              // 将token存储到sessionStorage
              sessionStorage.setItem("token", JSON.stringify(token));
              // 调用获取用户信息并等待完成
              await this.getInfo(token, true);
              // 标记为已登录（兼容多个登录入口）
              try {
                this.$store.commit("changeLoginState", true);
                sessionStorage.setItem("isLogin", "true");
              } catch (e) {
                console.warn("设置登录状态失败：", e);
              }
            }
          } catch (err) {
            console.error("通过 key 获取 token 失败：", err);
          }
        },
        // 检查并处理钉钉登录跳转
        checkAndHandleDingLogin() {
          // 防止重复执行钉钉登录跳转
          if (this.isDingLoginProcessing) {
            return;
          }
          
          // 获取钉钉登录数据
          const dingLoginData = sessionStorage.getItem('dingLoginData');
          if (!dingLoginData) {
            return;
          }
          
          try {
            const loginData = JSON.parse(dingLoginData);
            if (loginData.fromDingLogin && loginData.themeMenuId) {
              // 如果未登录，直接返回，不进行重试
              if (!this.isLogin) {
                return;
              }
              
              // 标记正在处理钉钉登录跳转
              this.isDingLoginProcessing = true;
              
              // 执行跳转
              this.openTabFromMenuId(loginData.themeMenuId);
            }
          } catch (error) {
            this.isDingLoginProcessing = false; // 重置处理标志
          }
        },
        // 根据菜单ID打开对应的标签页
        openTabFromMenuId(menuId) {
          try {
            // 从 sessionStorage 获取菜单数据
            const theMenuChilds = sessionStorage.getItem('theMenuChilds');
            let menuData = theMenuChilds ? JSON.parse(theMenuChilds) : [];
            if (!menuData || !Array.isArray(menuData) || menuData.length === 0) {
              setTimeout(() => {
                const retryMenuChilds = sessionStorage.getItem('theMenuChilds');
                let retryMenuData = retryMenuChilds ? JSON.parse(retryMenuChilds) : [];
                if (!retryMenuData || !Array.isArray(retryMenuData) || retryMenuData.length === 0) {
                  // 防止重复注册事件监听器
                  if (!this.isWaitingForMenuData) {
                    this.isWaitingForMenuData = true;
                    // 使用$once确保事件只触发一次，避免重复调用
                    this.$root.$once('menuDataLoaded', () => {
                      this.isWaitingForMenuData = false;
                      // 重新获取最新的菜单数据
                      const latestMenuChilds = sessionStorage.getItem('theMenuChilds');
                      let latestMenuData = latestMenuChilds ? JSON.parse(latestMenuChilds) : [];
                      if (latestMenuData && Array.isArray(latestMenuData) && latestMenuData.length > 0) {
                        this.processMenuData(latestMenuData, menuId);
                      }
                    });
                  }
                  return;
                }
                this.processMenuData(retryMenuData, menuId);
              }, 1000);
              return;
            }
            this.processMenuData(menuData, menuId);
          } catch (error) {
            // 打开菜单标签页失败时的错误处理
          }
        },
        
        processMenuData(menuData, menuId) {
          try {
            // 递归查找目标菜单项
            const findMenuItem = (menus, targetId) => {
              for (const menu of menus) {
                if (menu.id == targetId) {
                  return menu;
                }
                if (menu.childs && menu.childs.length > 0) {
                  const found = findMenuItem(menu.childs, targetId);
                  if (found) return found;
                }
              }
              return null;
            };
            
            const targetMenu = findMenuItem(menuData, menuId);
            
            if (targetMenu) {
              // 构造标签页对象，确保包含addTab方法需要的所有字段
              const tabObj = {
                title: targetMenu.name,
                index: targetMenu.id.toString(), // 使用菜单ID作为index
                id: targetMenu.id,
                component: targetMenu.componentName,
                studentPageId: targetMenu.studentPageId,
                remarks: targetMenu.remarks || '',
                prompt: targetMenu.prompt || false
              };
            // 延迟添加标签页，确保DOM完全渲染
            setTimeout(() => {
              this.addTab(tabObj);
              
              // 检查是否是钉钉登录跳转，如果是则清理数据
              const dingLoginData = sessionStorage.getItem('dingLoginData');
              if (dingLoginData && this.isDingLoginProcessing) {
                // 清除钉钉登录数据
                sessionStorage.removeItem('dingLoginData');
                // 移除事件监听器
                this.$root.$off('triggerDingLoginCheck', this.checkAndHandleDingLogin);
                // 重置处理标志
                this.isDingLoginProcessing = false;
              }
            }, 100);
            } else {
              this.$message.warning('未找到对应的菜单页面');
              
              // 如果是钉钉登录跳转但未找到菜单，也要重置处理标志
              if (this.isDingLoginProcessing) {
                this.isDingLoginProcessing = false;
              }
            }
          } catch (error) {
            // 处理菜单数据失败时的错误处理
          }
        },
      // 工作状态切换
      changeWorkState(type) {
        this.workState = type
        this.$refs?.workStateSwitch?.changeWorkState(type)
      },
      // 关闭signalR连接
      closeSignalRConnectionInChild() {
        if (this.$refs.systemMessageDialog) {
          this.$refs.systemMessageDialog.closeSignalRConnection();
        }
      },
      hideOther() {
        this.editableTabs.forEach((item) => {
          item.isTips = false;
        });
      },
      noTip(item) {
        this.editableTabs.forEach((i) => {
          if (i.title === item.title) {
            i.isTips = false;
            i.prompt = false;
          }
        });
        const arr = localStorage.getItem("currentMenuIsPrompt")
          ? JSON.parse(localStorage.getItem("currentMenuIsPrompt"))
          : [];
        arr.push({
          title: item.title,
          prompt: false,
        });
        const currentMenuIsPrompt = uniqBy(arr, "title");
        localStorage.setItem("currentMenuIsPrompt", JSON.stringify(currentMenuIsPrompt));
      },
      currentLeave() { },
      currentHover(el) {
        const elList = el.srcElement.childNodes;
        this.elList = elList;
        // 遍历监听elList
        elList.forEach((el) => {
          el.addEventListener("mouseenter", this.navHover);
          el.addEventListener("mouseleave", this.currentLeave);
        });
      },
      navHover(e) {
        // const currentNavId = e.srcElement.id
        // const currentNavTitle = e.srcElement.innerText;
        // this.editableTabs.forEach((item) => {
        //   item.isTips = item.title === currentNavTitle;
        // });
      },
      clickTab(e) {
        // this.editableTabs.forEach((item, index) => {
        //   item.isTips = false;
        // });
        if (!e) return;
        let tab = this.editableTabs.find(item => item.index === e.name);
        if (tab) {
          this.$refs.sidebar.setActive(tab.index)
        }
        this.loadApp(tab)
      },

      clickDeleteIcon(index, item) {
        item.disableRemark = true
        this.$set(this.editableTabs[index], "isTips", false);
      },
      // 提交登录新
      async submitClick(val) {
        let adminInfo = sessionStorage.getItem("AdminToken")
          ? JSON.parse(sessionStorage.getItem("AdminToken"))
          : [];
        this.isClickLogin = true;
        let expiresTime = adminInfo.expires_in + new Date() / 1000;
        const token = {
          AccessToken: adminInfo.access_token,
          AccessExpiresIn: expiresTime,
          RefreshToken: adminInfo.refresh_token,
        };

        this.$store.commit("saveTokenStorage", token);
        this.getInfo(token, val);
      },
      // 原有 旧
      async submitClick1() {
        this.isClickLogin = true;
        var grant_type = this.$route.query.grant_type;
        var client_id = this.$route.query.client_id;
        var clent_secret = this.$route.query.clent_secret;
        var adminId = JSON.parse(this.$Base64.decode(this.$route.query.adminId));
        await logIn1(grant_type, client_id, clent_secret, adminId).then((res) => {
          if (res.status === 200) {
            const data = res.data;
            let expiresTime = data.expires_in + new Date() / 1000;
            const token = {
              AccessToken: data.access_token,
              AccessExpiresIn: expiresTime,
              RefreshToken: data.refresh_token,
            };
            this.$store.commit("saveTokenStorage", token);
            this.getInfo(token);
          } else {
            this.isClickLogin = false;
          }
        });
      },
      async getInfo(token, val) {
        let AdminCache;
        if (val) {
          this.$message({ message: "登录成功！", type: "success" });
        }
         await loginRoleInformationV2().then((result1) => {
            if (result1.code == 1) {
              // 登录成功提示
              AdminCache = result1.result;
              sessionStorage.setItem("AdminCache", JSON.stringify(AdminCache)); //存储AdminCache
              loginUserInfo(AdminCache);
              const webStyle = JSON.parse(result1.result.webStyle);
              let ThemeColorBGR = hexToRgb(webStyle.ThemeColor);
              webStyle.ThemeColorBGR = ThemeColorBGR;
              result1.result.webStyle = JSON.stringify(webStyle);
              // 存储主题色
              let style;
              if (result1.result && result1.result.webStyle) {
                style = Object.assign(JSON.parse(result1.result.webStyle), defaultColor);
              } else {
                style = defaultThemeStyle;
              }
              this.getColorData(style); //更换主题色
              this.$store.commit("changeThemeColor", JSON.stringify(style));
              sessionStorage.setItem("themeStyle", JSON.stringify(style));
            } else {
              AdminCache = false;
              // this.$message.error({ message: "登录失败！", type: "success" });
              this.isClickLogin = false;
            }
          })

      },
      _decodeURIComponent(str) {
        try {
          return decodeURIComponent(str);
        } catch (e) {
          return str;
        }
      },
      defaultComponent() {
        let tab
        this.comps.map((item) => {
          this.editableTabs.push({
            title: item.name,
            name: item.id + "",
            content: item.title + "",
            remarks: item.remarks || "",
            isTips: false,
            prompt: item.prompt,
            index: (item.id - item.studentPageId).toString(),
            component: item.component, // **component的值必须与对应的vue文件名保持一致 **//
          });
          this.editableTabsValue = item.id - item.studentPageId + "";
          this.openAgin.push({
            title: item.name,
            name: item.id + "",
            id: item.id + "",
            content: item.title + "",
            // remarks: item.remarks ? item.remarks.replace(/\n/g, "<br>") : "",
            remarks: item.remarks || "",
            isTips: false,
            prompt: item.prompt,
            component: item.component, // **component的值必须与对应的vue文件名保持一致 **//
          });
          tab = this.editableTabs[0];
        });
        // 默认打开窗口--也需要调用loadApp方法
        this.loadApp(tab)
      },
      // 获取默认页面参数
      getDefaultPage(val) {
        this.default = val.id;
        this.defaultName = val.name;
        let tabObj = {
          component: val.component,
          name: val.id,
          title: val.name,
          studentPageId: val.studentPageId,
        };
        sessionStorage.setItem("tabObj", JSON.stringify(tabObj));
        sessionStorage.setItem("tabObjDefault", JSON.stringify(this.comps));
        if (val == null || val == undefined || val == "") {
          this.$message.warning("未设置默认菜单");
          return;
        }
        
        // 检查是否有钉钉登录数据，如果有则跳过默认菜单，只打开themeMenuId对应的菜单
        const dingLoginData = sessionStorage.getItem('dingLoginData');
        if (dingLoginData) {
          try {
            const loginData = JSON.parse(dingLoginData);
            if (loginData.fromDingLogin && loginData.themeMenuId) {
              // 将默认菜单添加到comps数组但不打开，只是为了保持数据结构
              if (JSON.stringify(this.comps) == "[]") {
                this.comps.push(val);
              } else {
                const exists = this.comps.some(item => item.id === val.id);
                if (!exists) {
                  this.comps.push(val);
                }
              }
              // 延迟执行钉钉登录跳转
              setTimeout(() => {
                this.checkAndHandleDingLogin();
              }, 100);
              return;
            }
          } catch (error) {
            console.error('解析钉钉登录数据失败:', error);
          }
        }
        
        // 正常流程：添加默认页面到comps数组并打开
        if (JSON.stringify(this.comps) == "[]") {
          this.comps.push(val);
          this.defaultComponent();
        } else {
          this.comps.map((item) => {
            if (item.id != val.id) {
              this.comps.push(val);
              this.defaultComponent();
            }
          });
        }
      },
      // 点击左侧菜单打开窗口
      addTab(targetObj, val) {
        // this.clickTab();
        this.isHover = false;
        setTimeout(() => {
          this.isHover = true;
        }, 2000);
        let newTabName = targetObj.index;
        this.editableTabsValue = newTabName;
        this.openPageData = targetObj;
        // 同一个窗口不能重复打开
        const oldtab = this.editableTabs.find((tab, index) => tab.index == newTabName);
        if (oldtab) {
          // this.clickTab();
          this.$message("当前窗口已打开");
          return false;
        }
        // 新增窗口
        const newTab = {
          title: targetObj.title,
          index: targetObj.index,
          name: newTabName,
          content: targetObj.title,
          visible: this.editableTabsValue === targetObj.title,
          isTips: false,
          prompt: targetObj.prompt,
          // remarks: targetObj.remarks ? targetObj.remarks.replace(/\n/g, "<br>") : "",
          remarks: targetObj.remarks || '',
          component: targetObj.component
        };
        this.editableTabs.push(newTab);
        // 强制触发Vue的响应式更新
        this.$forceUpdate();
        this.openAgin.push({
          title: targetObj.title,
          name: newTabName,
          id: targetObj.id,
          content: targetObj.title,
          visible: this.editableTabsValue === targetObj.title,
          isTips: false,
          prompt: targetObj.prompt,
          studentPageId: targetObj.studentPageId,
          // remarks: targetObj.remarks ? targetObj.remarks.replace(/\n/g, "<br>") : "",
          remarks: targetObj.remarks || '',
        });
        this.$nextTick(() => {
          if (!targetObj.remarks) return;
       
            this.showTips = targetObj.prompt;
        });
        this.clickTab();
        // 加载子应用
        this.loadApp(targetObj);
      },
      logOutTemp(){
        logOut()
      },
      // 加载子应用
      async loadApp(targetObj) {
        const container = document.getElementById(`subapp-viewport-${targetObj.component}-${targetObj.index}`);
        let currentContainer = `#subapp-viewport-${targetObj.component}-${targetObj.index}`;
        let currentRoute = targetObj.component;
        
        if (!this.loadedInstances[currentContainer]) {
          try {
            const token = this.$store.state.token || JSON.parse(sessionStorage.getItem('token'));
            const allConfig = JSON.parse(sessionStorage.getItem("allConfig"));
            const AdminCache = this.$store.state.AdminCache || JSON.parse(sessionStorage.getItem("AdminCache"));

            actions.setGlobalState({ token });
            actions.setGlobalState({
              mainAppMethods: {
                someMethod: this.addTab,
                removeTab:this.removeTab,
                logOutMethod:this.logOutTemp
              }
            });
            let portMap = {}
            if (process.env.NODE_ENV === 'development') {
              portMap = {
                administrators: 8181,// 管理员模块
                student: 8182, // 学员模块
                product: 8183, // 产品模块
                order: 8184, // 订单模块
                teach: 8185, // 教学模块
                report: 8186, // 报表模块
                word: 8187, // 单词模块
                invoicing: 8188, // 开票模块
                marketing: 8189 // 营销模块
              };
            } else if (process.env.NODE_ENV === 'production') {
              portMap = {
                administrators: '/child/qk-administrators/index.html',// 管理员模块
                student: '/child/qk-student/index.html', // 学员模块
                product: '/child/qk-product/index.html', // 产品模块
                order: '/child/qk-order/index.html', // 订单模块
                teach: '/child/qk-teach/index.html', // 教学模块
                report: '/child/qk-report/index.html', // 报表模块
                word: '/child/qk-word/index.html', // 单词模块
                invoicing: '/child/qk-invoicing/index.html', // 开票模块
                marketing: '/child/qk-marketing/index.html' // 营销模块
              };
            }


            const componentType =
              studentComponents.includes(targetObj.component) ? 'student' :
                adminComponents.includes(targetObj.component) ? 'administrators' :
                  orderComponents.includes(targetObj.component) ? 'order' :
                    productComponents.includes(targetObj.component) ? 'product' :
                      reportComponents.includes(targetObj.component) ? 'report' :
                        teachComponents.includes(targetObj.component) ? 'teach' :
                          wordComponents.includes(targetObj.component) ? 'word' : 
                          invoicingComponents.includes(targetObj.component) ? 'invoicing' :
                          marketingComponents.includes(targetObj.component) ? 'marketing' : ''
            
            // 添加时间戳或版本号，避免缓存问题
            const timestamp = new Date().getTime();
            const entry = process.env.NODE_ENV === 'development' 
              ? `//localhost:${portMap[componentType]}` 
              : `${`${portMap[componentType]}?v=${timestamp}`}?v=${timestamp}`;
            
            try {
              this.loadedInstances[currentContainer] = loadMicroApp({
                name: targetObj.component,
                entry,
                container: currentContainer,
                props: {
                  initialRoute: currentRoute,
                  onGlobalStateChange: actions.onGlobalStateChange,
                  setGlobalState: actions.setGlobalState,
                  allConfig,
                  AdminCache
                },
              }, {
                sandbox: { experimentalStyleIsolation: false }
              });
              try {
                // 等待挂载完成
                await this.loadedInstances[currentContainer].mountPromise;
              } catch (error) {
                // 挂载失败后的逻辑
                this.$set(this.appErrors, targetObj.component, `${targetObj.title}页面未运行，请联系技术人员处理！`);
              }
            } catch (error) {
              this.$set(this.appErrors, targetObj.component, `${targetObj.title}页面未运行，请联系技术人员处理！`);
            }
          } catch (error) {
            this.$set(this.appErrors, targetObj.component, `${targetObj.title}页面未运行，请联系技术人员处理！`);
          }
        }
      },
      // 移除窗口
      removeTab(targetName) {
        let tabs = this.editableTabs;
        if (tabs.length === 1) {
          this.$message({
            message: "至少保留一个窗口！",
          });
          return false;
        }
        let activeName = this.editableTabsValue;
        if (targetName == this.default) {
          // this.isFlag = false;
          this.isDefaultFlag = false;
          tabs.forEach((tab, index) => {
            if (tab.index === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.index;
              }
            }
          });
        }
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.index === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.index;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter((tab) => tab.index !== targetName);
        let delTab = tabs.filter((tab) => tab.index == targetName);

        this.editableTabs.forEach((item, index) => {
          item.isTips = false;
        });
        if (delTab && delTab.length > 0) {
          // 检查关闭的是否是 AddEditActivitySettings 相关的 tab
          const closedTab = delTab[0];
          if (closedTab && closedTab.component === 'AddEditActivitySettings') {
            // 通过全局状态通知需要刷新 ActivitySettings 列表
            actions.setGlobalState({
              refreshActivitySettings: Date.now() // 使用时间戳确保每次都能触发刷新
            });
          }
          this.delDisplayedTab(closedTab)
        }
      },
      delDisplayedTab(tab) {
        let currentContainer = `#subapp-viewport-${tab.component}-${tab.index}`;
        // 销毁其他已加载实例
        if (this.loadedInstances[currentContainer]) {
          this.loadedInstances[currentContainer].unmount();
          delete this.loadedInstances[currentContainer];
        }
      },
      // 是否显示工作状态切换功能：限 业务员角色 和 教务员角色 使用
      getIsPermission(payload) {
        const isPermissionWorkState = payload; // 子组件传出：当前用户是否有切换工作状态功能的权限
        // businessRoleId：业务员角色
        // educationalRoleId：教务员角色
        // groupLeaderRoleId：业务组长角色
        // marketingRoleId：客服角色
        const AdminCacheS = this.$store.state.AdminCache;
        const allConfig = JSON.parse(sessionStorage.getItem("allConfig"));
        const businessRoleId = allConfig ? allConfig.businessRoleId : null;
        const educationalRoleId = allConfig ? allConfig.educationalRoleId : null;
        const roleId = AdminCacheS ? AdminCacheS.rolesId : null;
        if (
          (roleId == businessRoleId || roleId == educationalRoleId) &&
          isPermissionWorkState
        ) {
          this.isShowWorkState = true;
        } else {
          window.sessionStorage.removeItem("workStateInt");
          this.isShowWorkState = false;
        }
      },
      //更换主题色
      async getColorData(style) {
        this.themeColorNew = style;
        this.setColor();
        this.postVersion(this.themeColorNew.ThemeColor);
      },
      // 获取角色主题，生成动态颜色样式
      setColor() {
        this.$nextTick(() => {
          document.querySelector("body").setAttribute(
            "style",
            `
        --ThemeColor: ${this.themeColorNew.ThemeColor || "#fd5252"};
        --ThemeColorBGR: ${this.themeColorNew.ThemeColorBGR || "#ecf5ff"};
        --SliderMenuColor: ${this.themeColorNew.SliderMenuColor || "#eef1f6"};
        --MenuFontColor: ${this.themeColorNew.MenuFontColor || "#333333"};
        --UnderlineColor: ${this.themeColorNew.UnderlineColor || "#48494b"};
        --HeadBgColor: ${this.themeColorNew.HeadBgColor || "#fd5252"};
        --HeadTextColor: ${this.themeColorNew.HeadTextColor || "#FFFFFF"};
        --Success: ${this.themeColorNew.Success || "#67C23A"};
        --Warning: ${this.themeColorNew.Warning || "#E6A23C"};
        --Danger: ${this.themeColorNew.Danger || "#F56C6C"};
        --Info: ${this.themeColorNew.Info || "#909399"};`
          );
        });
        this.$store.commit("changeThemeColor", JSON.stringify(this.themeColorNew));
      },

      //动态更新element-ui主题色 只需要给一个主题色
      async postVersion(theme) {
        const oldVal = this.chalk ? theme : ORIGINAL_THEME;
        if (typeof theme !== "string") return;
        const themeCluster = this.getThemeCluster(theme.replace("#", ""));
        const originalCluster = this.getThemeCluster(oldVal.replace("#", ""));
        const $message = this.$message({
          message: "更新主题中...",
          customClass: "theme-message",
          type: "success",
          duration: 0,
          iconClass: "el-icon-loading",
        });
        const getHandler = (variable, id) => {
          return () => {
            const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace("#", ""));
            const newStyle = this.updateStyle(
              this[variable],
              originalCluster,
              themeCluster
            );
            let styleTag = document.getElementById(id);
            if (!styleTag) {
              styleTag = document.createElement("style");
              styleTag.setAttribute("id", id);
              document.head.appendChild(styleTag);
            }
            styleTag.innerText = newStyle;
          };
        };
        if (!this.chalk) {
          const url = `https://unpkg.zhimg.com/element-ui@${version}/lib/theme-chalk/index.css`;
          try {
            await this.getCSSString(url, "chalk");
          } catch (error) {
            $message.close();
          }
        }
        const chalkHandler = getHandler("chalk", "chalk-style");
        chalkHandler();
        const styles = [].slice.call(document.querySelectorAll("style")).filter((style) => {
          const text = style.innerText;
          return new RegExp(oldVal, "i").test(text) && !/Chalk Variables/.test(text);
        });
        styles.forEach((style) => {
          const { innerText } = style;
          if (typeof innerText !== "string") return;
          style.innerText = this.updateStyle(innerText, originalCluster, themeCluster);
        });
        this.$store.commit("changeGlobalTheme", JSON.stringify(theme));
        $message.close();
      },
      updateStyle(style, oldCluster, newCluster) {
        let newStyle = style;
        oldCluster.forEach((color, index) => {
          if (newStyle)
            newStyle = newStyle.replace(new RegExp(color, "ig"), newCluster[index]);
        });
        return newStyle;
      },
      getCSSString(url, variable) {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
              this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, "");
              resolve();
            } else {
              reject();
            }
          };
          xhr.open("GET", url);
          xhr.send();
        });
      },
      getThemeCluster(theme) {
        const tintColor = (color, tint) => {
          let red = parseInt(color.slice(0, 2), 16);
          let green = parseInt(color.slice(2, 4), 16);
          let blue = parseInt(color.slice(4, 6), 16);
          if (tint === 0) {
            // when primary color is in its rgb space
            return [red, green, blue].join(",");
          } else {
            red += Math.round(tint * (255 - red));
            green += Math.round(tint * (255 - green));
            blue += Math.round(tint * (255 - blue));
            red = red.toString(16);
            green = green.toString(16);
            blue = blue.toString(16);
            return `#${red}${green}${blue}`;
          }
        };
        const shadeColor = (color, shade) => {
          let red = parseInt(color.slice(0, 2), 16);
          let green = parseInt(color.slice(2, 4), 16);
          let blue = parseInt(color.slice(4, 6), 16);
          red = Math.round((1 - shade) * red);
          green = Math.round((1 - shade) * green);
          blue = Math.round((1 - shade) * blue);
          red = red.toString(16);
          green = green.toString(16);
          blue = blue.toString(16);
          return `#${red}${green}${blue}`;
        };
        const clusters = [theme];
        for (let i = 0; i <= 9; i++) {
          clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
        }
        clusters.push(shadeColor(theme, 0.1));
        return clusters;
      },
    },
    // 组件销毁时关闭SignalR连接
    beforeDestroy() {
      this.closeSignalRConnectionInChild();
      window.removeEventListener('beforeunload', this.closeSignalRConnectionInChild);
    },
  };
</script>

<style lang="scss" scoped>
  .layout-wrapper {
    width: 100%;
    height: 100%;
    min-width: 1560px;
  }

  .custom-header {
    padding: 0;
    height: 45px !important;
  }

  .el-main {
    padding: 10px 10px 0;
  }

  .custom-tab-pane {
    border: 1px solid #e4e7ed;
    border-top: none;
    padding: 20px 10px;
    height: 100%;
    margin-bottom: 50px;
    position: absolute;
    width: 100%;
  }

  .icon-warning {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 1px solid;
    border-radius: 50%;
    text-align: center;
    line-height: 16px;
    margin-left: 4px;
  }

  .tips {
    .header {
      position: relative;
      display: flex;
      align-items: center;

      /* color: gray; */
      .el-icon-close {
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .content {
      max-width: 500px;
      min-width: 100px;
      white-space: wrap;
      margin-top: 10px;
      font-size: 16px;
      line-height: 30px;
    }

    .tipBtn {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      color: #4a7fe8;
    }
  }

  ::v-deep.el-tab-pane>div {
    height: 100%;
  }
</style>
<style>
  .el-tabs {
    height: 100%;
  }

  .el-tabs__header {
    margin: 0 !important;
  }

  .el-tabs .el-tabs__item {
    background-color: rgb(238, 241, 246);
    transition: none !important;

  }

  .el-tabs .el-tabs__item.is-active {
    transition: none !important;
    background-color: #fff;
  }

  .el-tabs__content {
    height: calc(100% - 41px);
    overflow: hidden;
  }
  
/* 禁用所有tab相关的过渡效果 */
.el-tabs__nav,
.el-tabs__nav-wrap,
.el-tabs__nav-scroll,
.el-tabs__item,
.el-tabs__item.is-active,
.el-tabs__item:hover {
  transition: none !important;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
}

/* 禁用popover的过渡效果 */
.el-popover,
.el-popover__reference {
  transition: none !important;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
}
</style>